import { render, staticRenderFns } from "./TargetAudienceTab.vue?vue&type=template&id=117243b2&scoped=true&"
import script from "./TargetAudienceTab.vue?vue&type=script&lang=js&"
export * from "./TargetAudienceTab.vue?vue&type=script&lang=js&"
import style0 from "./TargetAudienceTab.vue?vue&type=style&index=0&id=117243b2&lang=scss&scoped=true&"
import style1 from "./TargetAudienceTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117243b2",
  null
  
)

export default component.exports